// src/data/appLoader.js

import { lazy } from 'react';

export function loadAppComponent(name) {
  const map = {
    
    // Sidebar
    AppCatalogPage: lazy(() => import('../catalog/pages/AppCatalogPage.jsx')),
    AppDashboard: lazy(() => import('../layouts/components/AppDashboard')),
    UserProfilePage: lazy(() => import('../auth/user/UserProfilePage.jsx')),
    AdminDashboard: lazy(() => import('../layouts/components/dashboard/AdminDashboard')),
    FacilitatorAssignmentsPage: lazy(() => import('../features/assignments/views/FacilitatorAssignmentsPage.jsx')),
    InternalVocalRoutinePage: lazy(() => import('../internal/vocal-routine/InternalVocalRoutinePage.jsx')),

    //////////////////////
    ///// ACTIVITIES /////
    //////////////////////

    Attribute2AFC_Overall: lazy(() => import('../activities/two-afc/practice/Attribute2AFC_Overall.jsx')),
    Attribute2AFC_Roughness: lazy(() => import('../activities/two-afc/practice/Attribute2AFC_Roughness.jsx')),
    Attribute2AFC_Breathiness: lazy(() => import('../activities/two-afc/practice/Attribute2AFC_Breathiness.jsx')),
    Attribute2AFC_Strain: lazy(() => import('../activities/two-afc/practice/Attribute2AFC_Strain.jsx')),
    Attribute2AFC_Random: lazy(() => import('../activities/two-afc/practice/Attribute2AFC_Random.jsx')),

    VASAttributeRating: lazy(() => import('../activities/vas/attribute-rating/VASAttributeRating')),

    // Premium?
    HierarchicalOrdering: lazy(() => import('../activities/perceptual-training/HierarchicalOrdering')),
    DragToCategories: lazy(() => import('../activities/perceptual-training/DragToCategories')),
    SelfAssessmentFeedback: lazy(() => import('../activities/perceptual-training/SelfAssessmentFeedback')),
    PerceptualMap2D: lazy(() => import('../activities/perceptual-training/PerceptualMap2D')),
    PerceptionToSpectrogram: lazy(() => import('../activities/perceptual-training/PerceptionToSpectrogram')),
    BeforeAfterComparison: lazy(() => import('../activities/perceptual-training/BeforeAfterComparison')),
    AuditoryMemoryTraining: lazy(() => import('../activities/perceptual-training/AuditoryMemoryTraining')),
    FreeExplorationAnnotation: lazy(() => import('../activities/perceptual-training/FreeExplorationAnnotation')),


    // PLAY
    // Free
    GuessTheDiagnosis: lazy(() => import('../activities/games/GuessTheDiagnosis.jsx')),
    // Premium?
    GuessTheSpectrum: lazy(() => import('../activities/games/GuessTheSpectrum.jsx')),
    GuessTheSpectrogram: lazy(() => import('../activities/games/GuessTheSpectrogram.jsx')),
    GuessTheParameters: lazy(() => import('../activities/games/GuessTheParameters.jsx')),
    GuessTheRing: lazy(() => import('../activities/games/GuessTheRing.jsx')),

    // Practice
    OSRandomPractice: lazy(() => import('../activities/overall-severity/practice/OSRandomPractice')),
    OSSelectPractice: lazy(() => import('../activities/overall-severity/practice/OSSelectPractice')),
    CAPEVRandomPractice: lazy(() => import('../activities/cape-v/practice/CAPEVRandomPractice')),
    CAPEVSelectPractice: lazy(() => import('../activities/cape-v/practice/CAPEVSelectPractice')),
    CAPEVrRandomPractice: lazy(() => import('../activities/cape-vr/practice/CAPEVrRandomPractice')),
    CAPEVrSelectPractice: lazy(() => import('../activities/cape-vr/practice/CAPEVrSelectPractice')),
    EngineStandaloneRandomPracticePage: lazy(() => import('../features/engine/pages/EngineStandaloneRandomPracticePage.jsx')),
    EngineStandaloneSelectPracticePage: lazy(() => import('../features/engine/pages/EngineStandaloneSelectPracticePage.jsx')),
    EngineLiveModeratorPage: lazy(() => import('../features/live-sessions/pages/EngineLiveModeratorPage.jsx')),
    GRBASStandalonePage: lazy(() => import('../activities/grbas/GRBASStandalonePage.jsx')),
    GRBASLocalUploadPage: lazy(() => import('../activities/grbas/GRBASLocalUploadPage.jsx')),

    // Interact
  
    JoinSessionParent: lazy(() => import('../activities/live-sessions/session-views/JoinSessionParent')),
    OverallSeveritySessionParent: lazy(() => import('../activities/overall-severity/sessions/OverallSeveritySessionParent')),
    CAPEvSessionParent: lazy(() => import('../activities/cape-v/sessions/CAPEvSessionParent')),
    CAPEvrSessionParent: lazy(() => import('../activities/cape-vr/sessions/CAPEvrSessionParent')),
    CAPEVrSessionComingSoon: lazy(() => import('../activities/cape-vr/sessions/CAPEVrSessionComingSoon')),

    // Evaluate
    OSExploreForm: lazy(() => import('../activities/overall-severity/evaluate/OSExploreForm')),
    OSUpload: lazy(() => import('../activities/overall-severity/evaluate/OSUpload')),
    OSRecordComingSoon: lazy(() => import('../activities/overall-severity/evaluate/OSRecordComingSoon')),

    CAPEVExploreForm: lazy(() => import('../activities/cape-v/evaluate/CAPEVExploreForm')),
    CAPEVUpload: lazy(() => import('../activities/cape-v/evaluate/CAPEVUpload')),
    CAPEVRecordComingSoon: lazy(() => import('../activities/cape-v/evaluate/CAPEVRecordComingSoon')),

    CAPEVrExploreForm: lazy(() => import('../activities/cape-vr/evaluate/CAPEVrExploreForm')),
    CAPEVrUpload: lazy(() => import('../activities/cape-vr/evaluate/CAPEVrUpload')),
    
    // Record
    CapevrRecorderTool: lazy(() => import('../activities/cape-vr/record/CapevrRecorderTool')),
    VrpRecorderTool: lazy(() => import('../activities/voice-range-profile/record/VrpRecorderTool')),

    // Analyze

    CapeVrTool: lazy(() => import('../activities/cape-vr/record-or-upload/CapeVrTool')),

    SustainedAAnalysisTool: lazy(() => import('../activities/acoustic-analysis/sustained-a/SustainedAAnalysisTool')),
    VoiceRangeProfileTool: lazy(() => import('../activities/voice-range-profile/VoiceRangeProfileTool')),

    MptSzTool: lazy(() => import('../activities/aerodynamics/mpt-sz/MptSzTool')),

    PromsTool: lazy(() => import('../activities/proms/PromsTool')),

    // Conceptualize
    ClinicalTaxonomyArtisticVoice: lazy(() => import('../activities/conceptualization/categorization/ClinicalTaxonomyArtisticVoice')),
    PerceptualAttributesCategorization: lazy(() => import('../activities/conceptualization/categorization/PerceptualAttributesCategorization')),
    GeneralVoiceConceptsCategorization: lazy(() => import('../activities/conceptualization/categorization/GeneralVoiceConceptsCategorization')),

    // Participate
    WVDEvent: lazy(() => import('../activities/wvd/WVDEvent')),

    // Projects
    ProjectsHub: lazy(() => import('../features/projects/views/ProjectsHub.jsx')),


    // Code
    ResearchMethodologyGrid: lazy(() => import('../activities/research-methodology/ResearchMethodologyGrid.jsx')),
    ConceptsFreeSortingTask: lazy(() => import('../activities/sorting/concepts/ConceptsFreeSortingTask.jsx')),
    FreeSortingTask: lazy(() => import('../activities/sorting/samples/FreeSortingTask.jsx')),
    CollectionsFreeSortingTask: lazy(() => import('../activities/sorting/collections/CollectionsFreeSortingTask.jsx')),
    ConceptManager: lazy(() => import('../activities/conceptualization/tree/ConceptManager.jsx')),
    EARV: lazy(() => import('../activities/ear/ear-v/EARV.jsx')),
    ResourceBuilder: lazy(() => import('../activities/resource-builder/ResourceBuilder.jsx')),
    Anchors: lazy(() => import('../activities/anchors/Anchors')),
    TrainingPhases: lazy(() => import('../activities/training-in-three-phases/TrainingPhases')),
    VASexperiment: lazy(() => import('../activities/vas/experiments/vas-experiment/VASexperiment')),
    RandomVASexperiment: lazy(() => import('../activities/vas/experiments/random-vas-experiment/RandomVASexperiment')),
    TwoAFCexperiment: lazy(() => import('../activities/two-afc/experiment/TwoAFCexperiment')),
    //GeneralVoiceConceptsHierarchy: lazy(() => import('../activities/conceptualization/categorization/GeneralVoiceConceptsHierarchy')),

    // Admin
    AnalyticsDashboard: lazy(() => import('../admin/analytics/AnalyticsDashboard.jsx')),
    StrategyDashboard: lazy(() => import('../admin/strategy/StrategyDashboard.jsx')),
    ScienceDashboard: lazy(() => import('../admin/science/ScienceDashboard.jsx')),
    
    DeadlinesBoard: lazy(() => import('../admin/deadlines/DeadlinesBoard.jsx')),

    DocumentationPage: lazy(() => import('../admin/docs/DocumentationPage.jsx')),
    WorkstreamsPage: lazy(() => import('../admin/workstreams/WorkstreamsPage.jsx')),
    
    MapsView: lazy(() => import('../components/maps/MapsView')),
    IconGallery: lazy(() => import('../components/icons/IconGallery')),
    StudentPerformanceAnalyticsDemo: lazy(() => import('../admin/analytics/sections/demo/StudentPerformanceAnalyticsDemo')),


    //////////////////
    ///// LEGACY /////
    //////////////////

    AcademyAccessHub: lazy(() => import('../legacy/AcademyAccessHub')),
    GlobalDatabaseInvitation: lazy(() => import('../legacy/old-dashboard/GlobalDatabaseInvitation.jsx')),

    // LEGACY???

    WVDParticipate: lazy(() => import('../activities/wvd/WVDParticipate.jsx')),
  };

  return map[name] || null;
}
